export default `
      <link href='/snippets-style/footerRightNav.css' rel='stylesheet' />
      <div class="footer-right-nav">
      <div>
         <div class="menuTitle">Metode de plată</div>
         <div class="footer-payments-list">
            <a href="/deposit-skrill" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/payments/skrill.svg" alt="Skrill"></a>
            <a href="/deposit-neteller" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/payments/neteler.svg" alt="Neteller"></a>
            <a href="/deposit-safecharge" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/payments/mastercard.svg" alt="Mastercard"></a>
            <a href="/deposit-safecharge" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/payments/visa.svg" alt="Visa"></a>
         </div>
      </div>
      <div>
         <div class="menuTitle">CONTACTE</div>
         <ul class="footer-contacts-list">
            <li><a href="mailto:suport@favbet.ro">suport@favbet.ro</a></li>
            <li class="contacts-icons-title">HELP 24/7</li>
            <li class="contacts-icons">
               <a onclick="window.openWidget()"><img src="/images/snippetsMedia/contactsIcons/chat.svg" alt="Chat"></a>
               <a href="https://www.oki-toki.net/widget/?r=7775&lang=en" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/contactsIcons/support.svg" alt="Support"></a>
            </li>
         </ul>
         <div class="menuTitle">SUNTEM ÎN REȚELELE SOCIALE</div>
         <ul class="footer-list footer-socials-list">
            <li><a href="https://www.facebook.com/favbet.ro" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/socials/facebook.svg" alt="Facebook"></a></li>
            <li><a href="https://www.instagram.com/favbet.ro" target="_blank" rel="noreferrer"><img src="/images/snippetsMedia/socials/instagram.svg" alt="Instagram"></a></li>
         </ul>
      </div>
   </div>
`;
